/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReference = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10 6v2H8a4 4 0 0 0-.2 7.995L8 16h2v2H8a6 6 0 0 1-.225-11.996L8 6zm6 0a6 6 0 0 1 .225 11.996L16 18h-2v-2h2a4 4 0 0 0 .2-7.995L16 8h-2V6zm1 5v2H7v-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgReference as Reference };
